/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drab_Curly_Pug_RenewInputs */

const en_drab_curly_pug_renew = /** @type {(inputs: Drab_Curly_Pug_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended content`)
};

const de_drab_curly_pug_renew = /** @type {(inputs: Drab_Curly_Pug_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfohlener Inhalt`)
};

/**
* | output |
* | --- |
* | "Recommended content" |
*
* @param {Drab_Curly_Pug_RenewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const drab_curly_pug_renew = /** @type {((inputs?: Drab_Curly_Pug_RenewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drab_Curly_Pug_RenewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drab_curly_pug_renew(inputs)
	return de_drab_curly_pug_renew(inputs)
});